import { I18nProvider } from '@lingui/react';
import { PortalProvider } from '@mos-cat/portal';
import React from 'react';
import { i18n } from '../../../helpers/i18n';
import Viewport from '../Viewport/Viewport';

function Providers({ children }) {
  return (
    <I18nProvider language="ru" i18n={i18n}>
      <PortalProvider>
        <Viewport>{children}</Viewport>
      </PortalProvider>
    </I18nProvider>
  );
}

export default Providers;
